import { UUID } from '@cna/shared/generic-types';
import { Content, ContentType } from './content';
import { LegacyWoltersKluwerId } from '@cna/projects/ak-jura/shared/generic-types';

/**
 * Represents Wolters Kluwer content inside a (sub) section
 */
export interface WoltersKluwerContent extends Content {
    /**
     * Universally unique identifier version 3 of a section this content belongs to
     * For backwards compatibility also ids like 1:8077140,0 needs to be supported
     */
    documentRef: UUID | LegacyWoltersKluwerId;
    /**
     * Marginal ('Randziffer') together with documentRef identifies the content
     */
    marginal: string;
    /**
     * Optional: represents HTML text without styling information
     */
    text?: string;
    /**
     * Optional: Flag set by migration content. Can later be used to toggle between different display content.
     */
    showFormularDivs?: boolean;
    /**
     * Optional: Regex set by migration content. Used to identify all marginals with non-digits that should be concatenated into text property.
     * e.g.: marginal = 15, marginalRegex = 15[c-z]? -> All marginals with 15 or an additional identifier starting from 'c' are valid
     */
    marginalRegexString?: string;
}

export function isWoltersKluwerContent(value: unknown): value is WoltersKluwerContent {
    return typeof value === 'object' && value !== null && 'type' in value && value['type'] === ContentType.WoltersKluwer
}
